import {create} from 'zustand';
import logger from '../../logger';
import {Card} from '../../models/card';
import {getPaymentMethods} from '../../services/user';

type FetchCards = {
  token: string;
  brand: string;
  last4: string;
  expiryYear: number;
  expiryMonth: number;
}[];

export interface CardsProps {
  cards: Card[];
}

export interface CardsState extends CardsProps {
  fetchCards: () => Promise<FetchCards | undefined>;
  setCards: (cards: Card[]) => void;
  clearCards: () => void;
}

export const initialState: CardsProps = {
  cards: [],
};

export const useCards = create<CardsState>((set, get) => ({
  ...initialState,
  fetchCards: async () => {
    try {
      const {data} = await getPaymentMethods();
      set({cards: data.cards});
      return data.cards;
    } catch (reason) {
      set({cards: []});
      logger.error(reason);
    }
  },
  setCards: (cards) => ({
    cards,
  }),
  clearCards: () => ({
    cards: [],
  }),
}));
